import React from 'react';
import clubImage from '../assets/images/bg1.webp';

const AboutIntro = ({ language }) => {
  return (
    <section className="py-5 bg-light" id="about-intro">
      <div className="container">
        <div className="row align-items-center" data-aos="fade-up">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <img src={clubImage} alt="Officers Club" className="img-fluid rounded" />
          </div>
          <div className="col-lg-6">
<h2 className="fw-bold mb-3">
  {language === 'en' 
    ? 'About Ethiopian Defense Force Officers Club' 
    : 'ስለ የኢትዮጵያ መከላከያ ሠራዊት ኦፊሰሮች ክለብ'}
</h2>

<p>
  {language === 'en' 
    ? `Defence force officers club is established since 1992 
    and one of the beautiful places in the capital city Addis Ababa which is
     located in the Lideta sub-city in front of St. Paul Hospital just 100 meters far away 
     from the main road in a compound of the Ministry of Defence Army foundation. 
     It is a peaceful place to firstly aiming for recreation centre and hotel 
     services for both military, civil customers and for government & non-government
      organizations with well trained and experienced management and staffs
    `
    : `የመከላከያ ሃይል መኮንኖች ክበብ ከ1992 ዓ.ም 
    እና በዋና ከተማው አዲስ አበባ ውስጥ ከሚገኙት ውብ ቦታዎች አንዱ ነው
     ልደታ ክፍለ ከተማ ከቅዱስ ጳውሎስ ሆስፒታል ፊት ለፊት 100 ሜትር ርቀት ላይ ይገኛል። 
     በመከላከያ ሰራዊት ፋውንዴሽን ግቢ ውስጥ ከዋናው መንገድ. 
     በመጀመሪያ ለመዝናኛ ማእከል እና ለሆቴል ዓላማ የሚሆን ሰላማዊ ቦታ ነው። 
     ለወታደራዊ፣ ለሲቪል ደንበኞች እና ለመንግስት እና መንግስታዊ ያልሆኑ አገልግሎቶች
      በደንብ የሰለጠኑ እና ልምድ ያላቸው አስተዳደር እና ሰራተኞች ያሏቸው ድርጅቶች።`
  }
</p>

          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro;
